import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import LoadingSpinner from '../common/LoadingSpinner';

// Role-aware redirect for the bare /onboarding path (#1152). Parents land on
// /onboarding/parent; nannies fall through to /onboarding/nanny. Signed-out
// visitors also fall through, preserving the pre-existing login bounce
// (RequireRole sends them to /login with a return URL), and any other
// authenticated role is bounced to /dashboard by the nanny gate, exactly as
// before. Waits for session restore so a parent who hard-loads /onboarding
// is not mis-routed while auth state is still loading.
export const OnboardingRedirect: React.FC = () => {
  const { user, isAuthenticated, isLoading } = useAuth();

  if (isLoading) return <LoadingSpinner />;

  if (isAuthenticated && user?.role === 'parent') {
    return <Navigate to="/onboarding/parent" replace />;
  }
  return <Navigate to="/onboarding/nanny" replace />;
};
